<template>
  <div>
    <div class="shangke-card-comp"
      v-for="(item, index) in list" 
      :key="index" 
      @click="goDetail(item)">
      <!-- :class="{'is-end': item.feeWarn == 0}" -->
      <div class="title">
        <div class="title-l">
            <span class="tag"
              :class="{'card':(item.studentCardType == 1 && item.cardCourseTraded.cardType == 1),'card1':item.studentCardType == 2}">
              {{item.studentCardType == 1 ? (item.cardCourseTraded.cardType==1?'课时包':'课程'):'储值卡'}}
            </span>
            <span class="tag day-card" v-if="item.studentCardType == 1 && item.cardCourseTraded.chargeType === 2">按天</span>
            {{item.cardName}}
        </div>
        <!-- <div class="title-r" v-if="item.feeWarn == 0">已停用</div> -->
      </div>
      <div class="infos-nav">
        <div v-if="item.studentCardType == 2">
          <span class="item-name">持卡人：</span>
          <span>{{ item.storedCardAccount.storedCardName }} {{ item.storedCardAccount.storedCardPhone }}</span>
        </div>
        <div>
          <span class="item-name">{{item.studentCardType == 1 ? '所属校区：':'开卡校区：'}}</span>
          <span class="strong-val van-ellipsis">{{item.studentCardType == 1 ? item.cardCourseTraded.campusName : item.storedCardAccount.openCampusName}}</span>
        </div>
        <div v-if="item.studentCardType == 1">
          <span class="item-name">剩余数量：</span>
          <span :class="{'owe': item.cardCourseTraded.feeAmount && item.cardCourseTraded.feeAmount>0}">{{item.cardCourseTraded.totalRemainAmount}}{{item.cardCourseTraded.priceUnitName}}
            <template v-if="item.cardCourseTraded.feeAmount && item.cardCourseTraded.feeAmount>0">(欠费{{item.cardCourseTraded.feeAmount}}{{item.cardCourseTraded.priceUnitName}})</template>
          </span>
        </div>
        <div v-if="item.studentCardType == 2">
          <span class="item-name">当前余额：</span>
          <span>{{ item.storedCardAccount.allTotalMoney | formatNumber }}元</span>
        </div>
      </div>
      <div class="card-tag" v-if="item.studentCardType == 1 && item.cardCourseTraded.feeWarn == 0"></div>
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="暂无数据"
      v-if="!list||(list&&list.length==0)"
      image-size="128">
    </van-empty> 
  </div>
</template>

<script>
export default {
  name: 'shangke-card-comp',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    goDetail(item) {
      // studentCardType 学员卡包类型 1:上课卡 2:储值卡
      if (item.studentCardType==1 && app.permission.op('find_student_card_detail')) {
        this.$router.push(`/classCardDetail?campusId=${item.cardCourseTraded.campusId}&cardType=${item.cardCourseTraded.cardType}&studentId=${item.cardCourseTraded.studentId}&cardInfoId=${item.cardCourseTraded.cardInfoId}&curriculumId=${item.cardCourseTraded.curriculumId}&priceItemId=${item.cardCourseTraded.priceItemId}`);
      }
      if (item.studentCardType==2) {
        if (app.permission.op('query_stored_card || edit_stored_card || stored_card_bind_student')) {
          this.$router.push(`/storedCardDetail/${item.cardId}`);
        } else {
          vant.Toast('无查看储值卡详情权限，请联系管理员');
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .shangke-card-comp {
    position: relative;
    padding-bottom: calc(var(--gap) * 8);
    margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
    height: auto;
    color: var(--g8);
    border-radius: var(--radius-sm);
    overflow: visible;
    background-color: var(--white);
    // &.is-end{
    //   opacity: 0.4;
    // }
    .title {
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 6) calc(var(--gap) * 16);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g8);
      font-weight: var(--bold);
      .tag {
        margin-right: calc(var(--gap) * 4);
        display: inline-block;
        font-weight: normal;
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        height: var(--lh-sm);
        padding: 0 calc(var(--gap) * 4);
        color: var(--white);
        background: var(--c1);
        border-radius: 2px;
        &.card {
          background-color: var(--c4);
        }
        &.card1 {
          background-color: var(--c3);
        }
        &.day-card{
          color: var(--c1);
          border: 1px solid var(--c1);    
          background-color: transparent;
          box-sizing: border-box;
          vertical-align: middle;
        }
      }
    }
    .infos-nav {
      padding: 0 calc(var(--gap) * 16);
      color: var(--g6);
      > div {
        display: flex;
        margin: 0 0 calc(var(--gap) * 4);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        align-items: flex-start;
      }
      .item-name {
        flex-shrink: 0;
      }
      .strong-val {
        flex: 1;
      }
      .owe {
        color: var(--c3);
      }
    }
    .card-tag {
      right: 0;
      bottom: 0;
      position: absolute;
      width: calc(var(--gap) * 82);
      height: 0;
      padding-top: calc(var(--gap) * 82);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
      background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0092.png');
    }
  }
</style>